function replaceBackgroundColour(classList, colour) {
  const oldClasses = [];
  const newClasses = [];

  classList.forEach((c) => {
    if (c.indexOf('bg-color--') !== 0) return;

    // if there is an existing background colour class, we want to remove it
    oldClasses.push(c);

    // also check for the offset background classes
    const offsetIndex = c.indexOf('-offset');
    const newColour =
      offsetIndex < 0 ? colour : colour + c.substring(offsetIndex);

    // add our new colour classes to the element
    newClasses.push(`bg-color--${newColour}`);
  });

  // if no existing background colours were found, then we will still need to add a new colour class
  if (!newClasses.length) {
    newClasses.push(`bg-color--${colour}`);
  }

  classList.remove(...oldClasses);
  classList.add(...newClasses);
}

function randomiseBackground(background) {
  // check and see if there is a list of specified colours in the data attribute
  const colourList = background.dataset.randomBackgroundColour;
  const colours = colourList ? colourList.split(' ') : [];

  if (!colours.length) {
    // if no colours are specified in the data attribute, lets use any colour from the palette
    const base_colours = ['orange', 'green', 'blue-light', 'pink', 'peach'];
    colours.push(...base_colours);
  }

  // find a random colour from the available colours
  const colour = colours[Math.floor(Math.random() * colours.length)];

  replaceBackgroundColour(background.classList, colour);
}

function randomBackgroundColour() {
  const backgrounds = document.querySelectorAll(
    '[data-random-background-colour]',
  );

  backgrounds.forEach((background) => {
    randomiseBackground(background);
  });
}

export function init() {
  randomBackgroundColour();
}
